module.exports = __webpack_public_path__ + "img/map_area1_active.f74e96dd.png";